import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'

import './index.css'

export default function LoadingScreen({ withoutLoadingIcon = false }) {
    return <div className="loading-screen-container">{!withoutLoadingIcon && <LoadingOutlined />}</div>
}
